import { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { CREATE_GROUP_EVENT_NEW_PATH } from './create-event-form/quick-start-visibility'

// Opens the "How do you want to start?" picker over the current page. Render
// `CreateEventQuickStartOverlay` with `overlayProps` while `isOpen` is true.
// Start from Scratch continues into the create form; Template and Duplicate
// close the picker and carry on through the `?preload` flow on their own.
// `canBuildOwnEvent` is false when the coach has reached the starter group
// event limit; it travels with `overlayProps` so callers cannot spread them and
// forget the limit.
const useCreateEventQuickStart = ({ canBuildOwnEvent = true } = {}) => {
  const history = useHistory()
  const [isOpen, setIsOpen] = useState(false)

  const open = () => setIsOpen(true)
  const close = () => setIsOpen(false)

  return {
    isOpen,
    open,
    close,
    overlayProps: {
      canBuildOwnEvent,
      onCancel: close,
      onContinue: () => {
        close()
        history.push(CREATE_GROUP_EVENT_NEW_PATH, { skipQuickStart: true })
      },
      onSourceSelected: close,
    },
  }
}

export default useCreateEventQuickStart
